<template>
    <div>
        <popupFestival></popupFestival>
        <div id="wrap">
            <div class="container">
                <div class="login-con">
                    <!-- <div class="logo"><img src="assets/images/wsl/logo.png" width="290px"/></div> -->
                    <div class="login-detail">
                        <img :src="customTemplate['login_logo']" />
                        <form action="?" method="post" name="myForm" id="myForm" target="_self" autocomplete="off" class="basic-grey">  
                            <input type="hidden" name="fr_namamasuk">
                            <input type="hidden" name="fr_loginform" value="main" />
                            <input type="hidden" name="fr_language" value="<?php echo $_REQUEST['language'] ?>" />
                            
                                        <label>
                                            <span>{{ langList.login['LOGIN.LANGUAGE'] }} :</span></label> 		
                                        <label>
                                            <select name="language" @change="changeLanguage(selectedLang)" v-model="selectedLang">
                                                <option value="1" >{{langSelect[1].caption}}</option>
                                                <option value="2" >{{langSelect[2].caption}}中文</option>
                                                <option value="3" >{{langSelect[3].caption}}中文</option>
                                            </select>
                                        </label>               
                            <label>
                                <span>{{ langList.login['LOGIN.LBL_LOGIN'] }}:</span> 
                                <input type="text" id="username" name="fr_username" v-model="formData.accname" :maxlength="inputLength.username" :placeholder="langList.login['LOGIN.LBL_LOGIN'] " />
                            </label>
                            
                            <label>
                                <span>{{ langList.login['LOGIN.PASSWORD'] }}:</span>
                                <input type="password" id="fr_password" v-model="formData.pass" name="fr_password" :maxlength="inputLength.password" :placeholder="langList.login['LOGIN.PASSWORD']" />
                            </label>
                            <label>
                                <input type="submit" name="fr_submit" class="button" @click.prevent="login()" :value="langList.login['LOGIN.BTN_LOGIN']" /> 
                            </label>    
                        </form>
                    </div>
                
                </div>
                </div>
                
            <div class="footer-con">
                <div class="footer1"></div>
                <div class="footer2">
                    <table border="0" cellpadding="0" cellspacing="0" align="center">
                        <tr>
                            <td>Copyrights 2014. All Right Reserved. </td>
                            <td v-if="showLogo">Powered by &nbsp;<img :src="logoSwitch()" width="80" border="0" alt=""/></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import popupFestival from '../../components/popup-festival'
import authCommon from '../../mixins/authCommon'
export default {
  mixins: [authCommon],
    components: {
      popupFestival,
    },
    data() {
        return {
        companyName: window._companyname,
        selectedLang: null,
        langSelect: lang_select,
        cookielang: _cookie,
        lang: lang,
        langList: window.langList,
        formData: {
            accname: "",
            pass: ""
        },
        error: {
            loginIdReq: false,
            message: ""
        },
        sportList: _.keyBy(window._sportList, 'id'),
        sprtEvents: window._sportEventList ? window._sportEventList : [],
        hotMatchList: [],
        companycode: window.compcode,
        currentTemplate: window._currentTemplate,
        customTemplate: window._customTemplate,
	token :window.token,
        showLogo: window.showLogo,
        };
    },
    methods: {
        logoSwitch(){
            if(this.langSelected == 'en_US'){
                return 'assets/images/eng_3sing.png'
            }
            return 'assets/images/3sing.png'
        },
        changeLanguage: function(value) {
            this.$ajax({
                url: "",
                type: "get",
                data: {
                language: value
                }
            }).then(response => {
                window.location.reload();
            });
        },
        login() {
            if (this.formData.accname == "") {
                this.error.loginIdReq = true;
                this.error.message = this.lang.emptyLoginId;
                alert(this.error.message)
            } else if (this.formData.pass == "") {
                this.error.loginIdReq = true;
                this.error.message = this.lang.emptyPassword;
                alert(this.error.message)
            } else {
                this.error.loginIdReq = false;
                this.formData.token = token.arr_9+'|'+this.formData.accname
                this.$ajax({
                method: "post",
                url: "",
                data: this.formData
                }).catch(error => {
                this.error.loginIdReq = true;
                this.error.message = error.responseJSON.message;
                alert(this.error.message)
                });
            }
        },
    },
    mounted() {
        this.selectedLang = _.findKey(this.langSelect, {
        language_code: this.langSelected
        });
        $('#username').focus();
    }
}
</script>
<style lang="scss">
@import "~@/styles/auth/wxx";
</style>


// WEBPACK FOOTER //
// resources/whg/vue/apps/auth/wxx.vue